<template>
  <div id="Hotspot">
    <Head/>
    <div class="hotspot clear">
      <Nav ms='/Jurisdiction' />
      <div class="H-right">
        <div class="H-header">
          <input type="text" v-model="selName" placeholder="请输入公司名称查询">
          <select v-model="selStatus">
            <option value="0">未审核</option>
            <option value="1">已审核</option>
            <option value="2">已拒绝</option>
          </select>
          <div class="btn" @click="getinfo(1)">查询</div>
        </div>
        <div class="t_main">
          <el-table border :header-cell-style="{'background-color': '#001743','color': '#fff','height':'0.5rem'}" :stripe="true" :data="tableData1" style="width: 100%;" :row-style="{'height':'0.4rem'}">
            <el-table-column prop="ID" label="序号" header-align='center' align='center'></el-table-column>
            <el-table-column prop="Name" label="企业名称" header-align='center' align='center'></el-table-column>
            <el-table-column prop="RankName" label="级别" header-align='center' align='center'></el-table-column>
            <el-table-column prop="SuperiorDName" label="上级企业" header-align='center' align='center'></el-table-column>
            <el-table-column label="注册详情" header-align='center' align='center'>
              <template slot-scope="scope">
                <el-button size="mini" @click="Popups(1,scope.row)">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="watchnums" label="状态" header-align='center' align='center'>
              <template slot-scope="scope">
                <span>{{scope.row.Status==0?'待审核':scope.row.Status==1?'正常':'禁用'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align='center' align='center'>
              <template slot-scope="scope">
                <el-button size="mini" v-if="scope.row.Status==0" @click="Popups(1,scope.row)" type="primary">审核</el-button>
                <el-button size="mini" v-if="scope.row.Status==1" @click="setInfo(1,scope.row)" type="danger">禁用</el-button>
                <el-button size="mini" v-if="scope.row.Status==2" @click="setInfo(1,scope.row)" type="primary">启用</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="text-align: right;height: 0.45rem;" v-if="tableData1.length>0"
            @current-change="CurrentChange1"  @size-change="handleSizeChange1" :current-page="Page1" :page-size="PageSize1" :page-sizes="[10, 20, 30]" layout="total,sizes, prev, pager, next, jumper"
            :total="total1"></el-pagination>
        </div>
        <div class="Popup" v-show="isPopup">
          <div class="none" @click="Popups(0)"></div>
          <div v-if="isPopup" class="a_forms">
            <div class="f-top">
              <img src="../../assets/back/x.png" @click='Popups(0)' alt="">
              企业详情
            </div>
            <div class="f-info">
              <div class="f-title">
                <div class="f-left">
                  <div>
                    <span>名称</span>
                    <a>:</a>
                    <em>{{user.Name}}</em>
                  </div>
                  <div>
                    <span>隶属关系</span>
                    <a>:</a>
                    <em>山东能源集团有限公司</em>
                  </div>
                  <div>
                    <span>省份</span>
                    <a>:</a>
                    <em>山东省</em>
                  </div>
                  <div>
                    <span>企业性质</span>
                    <a>:</a>
                    <em>露天矿</em>
                  </div>
                  <div>
                    <span>城市</span>
                    <a>:</a>
                    <em>{{user.City}}</em>
                  </div>
                  <div>
                    <span>联系人员</span>
                    <a>:</a>
                    <em>{{user.Manager}}</em>
                  </div>
                  <div>
                    <span>所在部门</span>
                    <a>:</a>
                    <em>{{user.Department}}</em>
                  </div>
                </div>
                <div class="f-left f-right">
                  <div>
                    <span>职务</span>
                    <a>:</a>
                    <em>{{user.Position}}</em>
                  </div>
                  <div>
                    <span>联系电话</span>
                    <a>:</a>
                    <em>{{user.Phone}}</em>
                  </div>
                  <div>
                    <span>统一代码</span>
                    <a>:</a>
                    <em>{{user.Code}}</em>
                  </div>
                  <div>
                    <span>营业执照</span>
                    <a>:</a>
                  </div>
                  <img :src="user.Image||require('../../assets/back/110.png')" alt="营业执照">
                </div>
              </div>
              <div class="f-bottom" v-if="user.Status!=2">
                <span style="margin-right:0.2rem;">一键直报</span>
                <el-radio v-model="user.Specificity" label="1">是</el-radio>
                <el-radio v-model="user.Specificity" label="0">否</el-radio>
              </div>
              <div class="f-bottom" v-if="user.Status==0">
                <div style="margin-right:0.2rem;">审核结果</div>
                <div class="btn" @click="setInfo(1)" style="margin-right:0.2rem;">审核通过</div>
                <div class="btn" @click="setInfo(2)">审核拒绝</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
export default {
  name: "Jurisdiction",
  data() {
    return {
      total1:1,
      tableData1:[1],
      Page1:1,
      value:'1',
      PageSize1:10,
      user:'',
      isPopup: false,
      selName:'',
      selStatus:1,
    }
  },
  created() {
    this.getinfo();
  },
  methods:{
    Popups(a,b) {
      if(a == 1){
        this.user = Object.assign({}, b) 
      }
      this.isPopup = !this.isPopup
    },
    CurrentChange1(val) {
      //console.log(val)
      this.Page1 = val;
      this.getinfo()
    },
    handleSizeChange1(val) {
      //console.log(val)
      this.PageSize1 = val;
      this.getinfo(1)
    },
    getinfo(a){
      if(a == 1){
        this.Page1 = 1;
      }
      var that = this;
      that.$axios
        .post("company/index?token="+sessionStorage.getItem("token"),
        that.$qs.stringify({
          name:this.selName,
          status: this.selStatus,
          page: this.Page1,
          num: this.PageSize1
        }))
        .then(res => {
          if(res.data.code == 10000){
            console.log(res.data);
            this.tableData1 = res.data.data.list;
            this.total1 = res.data.data.total_num;
          }else{
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        })
    },
    setInfo(a,b){
      if(b){
        this.user = Object.assign({},b)
      }
      var that = this;
      this.user.Status = a;
      this.$confirm('确认提交吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$axios
							.post("company/update?token="+sessionStorage.getItem("token"),that.$qs.stringify(this.user))
							.then(res => {
								console.log(res)
								if (res.data.code == 10000) {
									that.$message({
										message: res.data.msg,
										type: 'success'
									});
                  that.getinfo();
                  this.Popups(0)
								}else{
									that.$message.error(res.data.msg);
								}
							});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});	
    },
  },
  components: {
    Head,
    Foot,
    Nav
  },
}
</script>
<style scoped lang="less">
.clear:after{/*伪元素是行内元素 正常浏览器清除浮动方法*/
		content: "";
		display: block;
		height: 0;
		clear:both;
		visibility: hidden;
}
.btn{
	width: 1rem;
  cursor: pointer;
	height: 0.4rem;
	line-height: 0.4rem;
	font-size: 0.17rem;
	text-align: center;
	background: #409EFF;
	border-radius: 0.04rem;
	color: #fff;
}
  .hotspot{
    width: 100%;
    min-width: 1000px;
    font-size:0.16rem;
    padding: 0.28rem 2.54rem;
    box-sizing: border-box;
    .H-right{
      position: relative;
      width: 11.5rem;
      min-width: 750px;
      padding-left: 0.2rem;
			height: 100%;
      float: right;
      min-height: 7.4rem;
      border-left: 1px #eeeeee solid;
      .H-header{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 0.5rem;
        span,select,div,input{
          margin-right: 0.2rem;
        }
        input,select{
          height: 0.4rem;
          width: 2rem;
          padding: 0.05rem;
        }
      }
    }
  }
  .Popup {
    width: 100%;
    position: absolute;
    top:0;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1000;

    .none {
      width: 100%;
      height: 100%;
      position: relative;
    }
    .a_forms {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      width: 10.11rem;
      // height: 6.49rem;
      background: white;
      font-size: 0.16rem;
      .f-top{
        height:0.5rem;
        width: 100%;
        text-align: center;
        line-height: 0.5rem;
        position: relative;
        border-bottom: 1px #cfcfcf solid;
        img{
          position: absolute;
          right: 0.1rem;
          top: 50%;
          transform: translate(0,-50%);
        }
      }
      .f-info{
        padding:0 0.54rem;
        .f-title{
          position: relative;
          overflow: hidden;
          padding-bottom: 0.5rem;
          border-bottom: 1px #cfcfcf solid;
          .f-left{
            overflow: hidden;
            position: relative;
            >img{
              margin-left: 1.2rem;
              margin-top: -0.5rem;
            }
            >div{
              margin:0.3rem 0.18rem;
              vertical-align: top;
              >span{
                width: 0.8rem;
                text-align: justify;
                text-align-last: justify;
                color: #505050;
                display: inline-block;
              }
              >a{
                color: #505050;
                font-style: normal;
              }
              >em{
                margin-left:0.3rem;
                color: #272727;
                font-style: normal;
              }
            }
          }
          .f-right{
            position: absolute;
            top: 0;
            right: 0;
            width: 50%;
          }
        }
        .f-bottom{
          margin: 0.2rem 0.2rem;
          display: flex;
          align-items: center;
        }
      }
    }
  }
</style>